const LINKS = {
  "Google Scholar": "https://scholar.google.com/citations?hl=en&user=imgWSakAAAAJ",
  "Orcid": "https://orcid.org/0000-0002-7183-4411",
  "github": "https://github.com/chanyingchi",
  "LinkedIn": "https://www.linkedin.com/in/ying-chi-ginny-chan-65044a170/",
  "ResearchGate": "https://www.researchgate.net/profile/Ying_Chi_Chan"
  
  
};

export const NAME = "Ying-Chi (Ginny) Chan";
export const EMAIL = "YingChi.Chan@ntu.edu.sg";

export default LINKS;
